class Config {
	constructor(domain) {
		this.domain = domain;
		this.tablePageSize = 10;
		this.dashboardSpacer = 48;
		this.dashboardSpacerMD = 56;
		this.reauthGap = 5 * 60 * 1000;
		this.baseURL = 'https://bcngarden.io';
	}

	setServers(mode) {
		this.mode = mode;
		if (mode === 'dev') {
			this.server = 'http://127.0.0.1:3009/api';
			this.socketServer = 'http://127.0.0.1:3002';
		}
		if (mode === 'prod') {
			this.server = 'https://bcngarden.services/api';
			this.socketServer = 'https://bcngarden.services:3002';
		}
	}
}

const config = new Config('app');
// const config = new Config('backOffice');

config.setServers('prod');

export default config;
